import React, { FC, ReactNode, useEffect } from 'react'
import { inject } from 'mobx-react'
import { GrFormClose } from 'react-icons/gr'
import { ClickAwayListener, Grow, Paper, Popper } from '@material-ui/core'
import './styles.scss'

interface Props {
  openDaysPopper: boolean
  anchorRef: React.RefObject<HTMLButtonElement>
  children: ReactNode
  setOpenDaysPopper: (value: boolean) => void
}

const DaysPopper: FC<Props> = ({ children, anchorRef, openDaysPopper, setOpenDaysPopper }) => {
  const handleCloseDaysPopper = (event?: React.MouseEvent<EventTarget>): void => {
    if (anchorRef.current && anchorRef.current.contains(event?.target as HTMLElement)) {
      return
    }

    setOpenDaysPopper(false)
  }
  const prevOpen = React.useRef(openDaysPopper)
  useEffect(() => {
    if (prevOpen.current === true && openDaysPopper === false) {
      anchorRef?.current?.focus()
    }

    prevOpen.current = openDaysPopper
  }, [openDaysPopper])
  return (
    <Popper
      open={openDaysPopper}
      anchorEl={anchorRef.current}
      role={undefined}
      transition
      disablePortal
      style={{
        zIndex: 2,
      }}
    >
      {({ TransitionProps, placement }): JSX.Element => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
          }}
        >
          <Paper style={{ maxWidth: 400, float: 'right' }}>
            <ClickAwayListener onClickAway={handleCloseDaysPopper}>
              <div className="days-form">
                {children}
                <GrFormClose
                  className="days-close"
                  onClick={(): void => setOpenDaysPopper(false)}
                />
              </div>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  )
}

export default inject('prospects', 'related', 'search')(DaysPopper)
